// test129
(129 && 0);
